var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturizationTuning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0084FF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 18,
    className: "st0",
    width: 50,
    height: 54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,51.9h9.2v3h-5.8v2.6h5.5v2.9h-5.5v5.8h-3.4V51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,51.9h5.4l1.7,6.2c0.2,0.6,0.3,1.3,0.5,2l0.3,1.3l0.4,1.7h0.1c0.2-0.8,0.4-1.6,0.5-2.3s0.4-1.6,0.7-2.8 l1.6-6.1h5.3v14.3h-3.3V60c0-2.5,0-4.4,0.1-5.6h-0.1C71.5,57,71,59,70.6,60.4L69,66.2h-3.7l-1.6-5.9l-0.8-3 c-0.3-1.2-0.5-2.1-0.7-2.9h-0.1c0,1.5,0.1,3,0.1,4.3v7.5H59V51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,54.8h-3.5v-3H88v3h-3.5v11.3h-3.4V54.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturizationTuning);
export default __webpack_public_path__ + "static/media/FeaturizationTuning.751464665208c5200d20af309cfbb9d7.svg";
export { ForwardRef as ReactComponent };